import { signOut } from "aws-amplify/auth";
import {
  redirectToHostedUiLogout,
  type SignOutRedirectConfig,
} from "./signOutCurrentClient";

/**
 * Revokes the user's refresh tokens across every Cognito app client. This is
 * intentionally separate from the default current-client sign-out because it
 * also signs the user out of other devices, including the mobile app.
 */
export async function signOutEverywhere(
  redirectConfig?: SignOutRedirectConfig,
): Promise<void> {
  const validRedirectConfig =
    typeof window !== "undefined" &&
    redirectConfig?.clientId &&
    redirectConfig.domain &&
    redirectConfig.redirectUri
      ? redirectConfig
      : undefined;

  try {
    await signOut({ global: true });
  } catch (error) {
    if (!validRedirectConfig) {
      throw error;
    }

    try {
      redirectToHostedUiLogout(validRedirectConfig);
    } catch {
      // Preserve the original sign-out error if redirecting also fails.
    }

    throw error;
  }

  if (validRedirectConfig) {
    redirectToHostedUiLogout(validRedirectConfig);
  }
}
